import { h } from 'preact'
import cx from '../../shared/classes'
import * as style from './style.css'

interface Props {
    icon: () => JSX.Element
    isSelected?: boolean
    onClick: () => void
}
const PatientType: preact.FunctionalComponent<Props> = ({ children, icon, isSelected, onClick }) => {
    return (
        <div
            onClick={onClick}
            class={cx({
                [style.patientType]: true,
                [style.patientTypeSelected]: isSelected,
            })}
        >
            <div class={style.patientTypeIcon}>{icon()}</div>
            <div class={style.patientTypeLabel}>{children}</div>
        </div>
    )
}

export default PatientType
